import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchColumnsVPO } from "../../api/api";
import { fetchColumnsSuccess, fetchColumnsFailure } from "./columns";
import { FetchColumnsParams } from "../../types/request";

type FetchDirectionsAction = {
  type: string;
  payload: FetchColumnsParams
}

export function* handleFetchColumns(action: FetchDirectionsAction): SagaIterator {
  try {
    const data = yield call(fetchColumnsVPO, action.payload);
    yield put(fetchColumnsSuccess(data));
  } catch (error) {
    yield put(fetchColumnsFailure(error.message));
  }
}
